// use to perform various tasks on the data from the API
const dataHelper = {};

// checks that a BIC code is valid (1 capital letter + 6 digits)
dataHelper.isValidCode = code => {
  return (/^[A-Z][0-9]{6}$/.test(code));
};

// checks that all the BIC codes in the array are valid
dataHelper.isValidCodeArray = codes => {
  if (Array.isArray(codes)) {
    return codes.reduce((acc, cur) => acc && dataHelper.isValidCode(cur), true);
  }
  return false;
};

// checks that an id code is a valid MongoDB _id (24 lower-case letters or digits) eg: 555bb0e425a9732ca20a3784
dataHelper.isValidId = id => {
  return (/^[a-z0-9]{24}$/.test(id));
};

// Given an array of Objects, return Object By Id
dataHelper.getObjBydId = (objs,id) => {
  if (objs && Array.isArray(objs) && id) {
    return objs.find(el => el.id === id);
  }
  return null;
};

dataHelper.getPropertyInObject = (obj, property) => {
  if (obj && property && property in obj) {
    return obj[property];
  }
  return null;
};

dataHelper.getNameById = (objs,id) => {
  return function (property) {
    return dataHelper.getPropertyInObject(dataHelper.getObjBydId(objs,id), property);
  }('name');
};

dataHelper.clone = (obj) => { 
  if(typeof(obj) == "object"){
    return JSON.parse(JSON.stringify(obj));
  }
  return null;
}

dataHelper.sanitizeString = (value) => {
  if (value) {
    return value.trim().replace(/[^a-zA-Z\d\s]/g, " ").replace(/\s\s+/g, ' ').trim();
  }
  return value;
}

export default dataHelper;